<template>
  <div class="inp_combo center phone">
    <Selector ref="mobileFirstNoElement" placeholder="선택" :options="mobileFirstNoOptions" v-model="mobileFirstNo" />
    <span class="anchor">-</span>
    <InputText ref="mobileRestNoElement" :formClass="formClass" type="tel" v-model.trim="mobileRestNo" onlyNumber maxlength="8" placeholder="(-없이) 최대 8자리 입력" clearable />
  </div>
</template>

<script>
import { computed, defineComponent, ref, toRefs, unref, watch } from '@vue/composition-api';
import InputText from './InputText';
import Selector from './Selector';

const MOBILE_FIRST_NO_OPTIONS = [
  { label: '010', val: '010' },
  { label: '011', val: '011' },
  { label: '016', val: '016' },
  { label: '017', val: '017' },
  { label: '018', val: '018' },
  { label: '019', val: '019' },
];

export default defineComponent({
  components: {
    InputText,
    Selector,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: String,
      default: '010',
    },
    formClass: String,
  },

  setup(props, { emit }) {
    const { value } = toRefs(props);
    const valueOnlyNumber = computed(() => unref(value).replace(/[^0-9]/g, ''));
    const mobileFirstNoElement = ref();
    const mobileRestNoElement = ref();

    const partialNumbers = computed(() => {
      const valueWithoutDash = unref(valueOnlyNumber);
      const middleNumbers = valueWithoutDash.length === 10 ? 3 : 4;
      return [valueWithoutDash.substr(0, 3), valueWithoutDash.substr(3, middleNumbers), valueWithoutDash.substr(3 + middleNumbers, 4)].filter(Boolean);
    });

    const mobileFirstNo = computed({
      get: () => unref(valueOnlyNumber).substr(0, 3),
      set: (value) => {
        const [, middleNumber, lastNumber] = unref(partialNumbers);
        emit('change', [value, middleNumber, lastNumber].filter(Boolean).join('-'));
      },
    });
    const mobileRestNo = computed({
      get: () => unref(valueOnlyNumber).substr(3, 8),
      set: (value) => {
        const middleNumbers = value === 7 ? 3 : 4;
        const [firstNumber] = unref(partialNumbers);
        emit('change', [firstNumber, value.substr(0, middleNumbers), value.substr(middleNumbers, 4)].filter(Boolean).join('-'));
      },
    });

    return {
      mobileFirstNoOptions: computed(() => MOBILE_FIRST_NO_OPTIONS),

      mobileFirstNoElement,
      mobileRestNoElement,
      mobileFirstNo,
      mobileRestNo,

      partialNumbers,

      focus() {
        unref(mobileRestNoElement)?.focus?.();
      },
    };
  },
});
</script>
